module.exports = __webpack_public_path__ + "img/type--2-spans--single-lang--fr.73915403.jpg";